




















import { Component, Vue, Prop } from "vue-property-decorator";
import { ElButton } from "element-ui/types/button";
@Component
export default class ConfirmDialog extends Vue {
  @Prop() title: string;
  @Prop() titleSubmit: string;
  @Prop() titleCancel: string;
  @Prop() msg: string;
  @Prop({ default: false })
  noBtnSubmit: boolean;
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop({ default: false })
  visible: boolean;
  @Prop({ default: false })
  isHtml: boolean;
  @Prop() customClass: string;
  
  showDialog: boolean = false;

  $refs!: {
    btnSubmit: ElButton;
    btnCancel: ElButton;
  };

  created() {
    if (this.visible) {
      this.showDialog = true;
    }
  }

  onDialogOpened() {
    if (this.noBtnSubmit) {
      this.$refs.btnCancel.$el.focus();
    } else {
      this.$refs.btnSubmit.$el.focus();
    }
  }

  onOpen() {
    this.showDialog = true;
  }

  onClose() {
    this.showDialog = false;
    this.$emit("onclose");
  }

  onSubmit() {
    this.$emit("onsubmit");
    this.showDialog = false;
  }

  onCancel() {
    this.$emit("oncancel");
    this.showDialog = false;
  }
}
